import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import React from "react";

const Partners = () => {
  return (
    <Box
      w="100%"
      pt={{ base: "105px", lg: "156px" }}
      pb={{ base: "61px", lg: "81px" }}
      overflowX="hidden"
      overflowY="visible"
      px={{ base: 5, lg: 0 }}
    >
      <Flex
        w={{ md: "85%" }}
        flexDir={{ base: "column", lg: "row" }}
        alignItems={{ base: "center", lg: "start" }}
        mx="auto"
      >
        <Text
          textAlign={["center", "start"]}
          maxW="196px"
          color="#131316"
          fontSize="0.9rem"
          lineHeight="24px"
          mr={{ lg: "40px" }}
          fontWeight="400"
          mb={{ base: "16px", lg: "0px" }}
        >
          Trusted by fast-growing companies around the world
        </Text>

        <motion.div
          initial={{ opacity: 0, x: 200 }}
          transition={{ delay: 0.3, duration: 2 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          style={{ flex: 4, zIndex: 1 }}
        >
          <Flex
            justify={{ base: "center", lg: "space-between" }}
            alignItems={"center"}
            flexWrap={["wrap", "nowrap"]}
            gap={5}
          >
            <Image
              src="/assets/svg/candor.svg"
              h={{ base: "22px", md: "25px" }}
              borderWidth={{ lg: 3 }}
              borderColor={"#000"}
            />
            <Image
              src="/assets/svg/level.svg"
              h={{ base: "22px", md: "25px" }}
              borderWidth={{ lg: 3 }}
              borderColor={"#000"}
            />
            <Image
              src="/assets/svg/graffbase.svg"
              h={{ base: "22px", md: "25px" }}
              borderWidth={{ lg: 3 }}
              borderColor={"#000"}
            />
            <Image
              src="/assets/svg/seam.svg"
              h={{ base: "22px", md: "25px" }}
              borderWidth={{ lg: 3 }}
              borderColor={"#000"}
            />
            <Image
              src="/assets/svg/honey.svg"
              h={{ base: "22px", md: "25px" }}
              borderWidth={{ lg: 3 }}
              borderColor={"#000"}
            />
            <Image
              src="/assets/svg/pano.svg"
              h={{ base: "22px", md: "25px" }}
              borderWidth={{ lg: 3 }}
              borderColor={"#000"}
            />
            <Image
              src="/assets/svg/covalent.svg"
              h={{ base: "22px", md: "25px" }}
              borderWidth={{ lg: 3 }}
              borderColor={"#000"}
            />
            <Image
              src="/assets/svg/saas.svg"
              h={{ base: "22px", md: "25px" }}
              borderWidth={{ lg: 3 }}
              borderColor={"#000"}
            />
          </Flex>
        </motion.div>
      </Flex>
    </Box>
  );
};

export default Partners;
